export {
  default as EncountersComponent,
  renderEncountersComponent,
} from './EncountersComponent';

export * from './config';
